import styled from 'styled-components';
import { getObjectWithSelector } from '../../../functions/objectFunctions/getObjectWithSelector';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { sizeUnits } from '../../../types/units';
import { PositioningInput } from '../inputs/PositioningInput';
import { UnitInput } from '../inputs/UnitInput';

export const PositioningInputGroup = ({
  variant,
  tab,
  pseudoclass,
}: {
  variant?: string;
  tab?: string;
  pseudoclass?: string;
}) => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });

  let selector: string = 'props.class';
  if (variant && tab) {
    selector = `props.class.variants.${variant}.${tab}`;
  }

  if (pseudoclass === 'none') pseudoclass = undefined;
  if (pseudoclass) {
    selector = `${selector}.&:${pseudoclass}`;
  }

  const styleObj = getObjectWithSelector(selectedElement, selector);

  const labelWidth = 100;

  return (
    <Container>
      <PositioningInput
        key={`${lastSelectedElementID}-${variant}-positioning-${tab}-${pseudoclass}-input`}
        label="Content Positioning"
        direction={styleObj?.flexDirection || 'row'}
        align={
          styleObj?.display !== 'flex'
            ? 'flex-start'
            : styleObj?.flexDirection === 'row'
            ? styleObj?.alignItems
            : styleObj?.justifyContent || 'flex-start'
        }
        justify={
          styleObj?.display !== 'flex'
            ? 'flex-start'
            : styleObj?.flexDirection === 'row'
            ? styleObj?.justifyContent
            : styleObj?.alignItems || 'flex-start'
        }
        onChange={(positioning) => {
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.display`]: 'flex',
              [`${selector}.flexDirection`]: positioning.direction,
              [`${selector}.justifyContent`]:
                positioning.direction === 'row'
                  ? positioning.justify
                  : positioning.align,
              [`${selector}.alignItems`]:
                positioning.direction === 'row'
                  ? positioning.align
                  : positioning.justify,
            })
          );
        }}
      />
      <UnitInput
        id={`${lastSelectedElementID}-${variant}-gap-${tab}-${pseudoclass}-input`}
        label="Gap"
        value={styleObj?.gap}
        units={sizeUnits}
        defaultUnit="px"
        onChange={(inputValue) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.display`]: 'flex',
              [`${selector}.gap`]: inputValue,
            })
          )
        }
        labelWidth={labelWidth}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
